module.exports = __webpack_public_path__ + "img/effenaar-experiences-qr-code-google.8af9b08f.png";